import Dashboard from "./Dashboard"


function index() {
  return (
    <div>
            <div className="py-3 border-b-2  flex justify-between items-center">
            <strong className="text-gray-500 ps-3">Insurance Dashboard</strong>
            </div>
            <Dashboard/>



    </div>
  )
}

export default index
